import { render, staticRenderFns } from "./CPrivacy.vue?vue&type=template&id=530a471d&scoped=true&"
var script = {}
import style0 from "./CPrivacy.vue?vue&type=style&index=0&id=530a471d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530a471d",
  null
  
)

export default component.exports